export default (function (actual) {
  var msg = 'Key must be ';

  for (var _len = arguments.length, types = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    types[_key - 1] = arguments[_key];
  }

  if (types.length > 2) {
    var last = types.pop();
    msg += "one of type ".concat(types.join(', '), ", or ").concat(last, ".");
  } else if (types.length === 2) {
    msg += "one of type ".concat(types[0], " or ").concat(types[1], ".");
  } else {
    msg += "of type ".concat(types[0], ".");
  }

  if (actual == null) {
    msg += " Received ".concat(actual);
  } else if (typeof actual === 'function' && actual.name) {
    msg += " Received function ".concat(actual.name);
  } else if (typeof actual === 'object' && actual != null) {
    if (actual.constructor && actual.constructor.name) {
      msg += " Received an instance of ".concat(actual.constructor.name);
    }
  }

  return msg;
});